import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, stagger, fadeUp } from "@/lib/motion";
import { WHY_CHOOSE } from "@/lib/site-data";
import { scrollToSection } from "@/lib/scroll";

const WhyChoose = () => {
  return (
    <section
      id="about"
      data-testid="why-choose-section"
      className="relative mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-ink-soft p-8 md:p-16">
        <div
          className="glow-orb h-[380px] w-[380px]"
          style={{ top: "-6rem", right: "-4rem", background: "#a855f7", opacity: 0.28 }}
          aria-hidden
        />
        <div className="relative grid grid-cols-1 gap-14 lg:grid-cols-[0.85fr_1.15fr]">
          <Reveal>
            <span className="eyebrow">The difference</span>
            <h2 className="mt-5 font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
              Why businesses choose Yas Solutions
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-white/60 md:text-lg">
              We combine the polish of a high-end studio with the personal care of a
              partner who genuinely wants you to win.
            </p>
            <button
              onClick={() => scrollToSection("contact")}
              data-testid="why-choose-cta"
              className="mt-8 rounded-full bg-white px-6 py-3 text-sm font-semibold text-black transition-transform duration-300 hover:scale-[1.03]"
            >
              Start a conversation
            </button>
          </Reveal>

          <motion.div
            variants={stagger(0.07)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="grid grid-cols-1 gap-4 sm:grid-cols-2"
          >
            {WHY_CHOOSE.map((w) => (
              <motion.div
                key={w.title}
                variants={fadeUp}
                data-testid={`why-item-${w.title.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
                className="rounded-2xl border border-white/10 bg-white/[0.02] p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-neon-cyan to-neon-purple text-black">
                    <Check className="h-4 w-4" strokeWidth={3} />
                  </span>
                  <h3 className="font-heading text-base font-semibold text-white">
                    {w.title}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-white/55">{w.text}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
